import { Box, Divider, makeStyles, Theme, Typography } from '@material-ui/core';
import { IAdjustmentReadResourceV22 } from 'components/basket/model/Basket';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CouponItem } from 'components/order/coupons/CouponItem';
import { CouponInput } from 'components/order/coupons/CouponInput';

const useStyles = makeStyles((theme: Theme) => ({
    title: {
        fontWeight: 700,
        fontSize: '18px'
    },
    linkText: {
        fontWeight: 700,
        color: theme.palette.primary.main
    }
}));

interface PayCouponsProps {
    onAdd: (coupon: string) => void;
    coupons?: IAdjustmentReadResourceV22[];
    loading?: boolean;
    onRemove: (coupon: string) => void;
}

export const PayCoupons: React.FC<PayCouponsProps> = ({ onAdd, coupons, loading, onRemove }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const handleRemoveCoupon = React.useCallback(
        (coupon?: string) => {
            if (coupon) {
                onRemove(coupon);
            }
        },
        [onRemove]
    );
    const renderCoupon = React.useCallback(
        (adjustment: IAdjustmentReadResourceV22) => (
            <CouponItem onClick={handleRemoveCoupon} adjustment={adjustment} key={adjustment.couponCode} />
        ),
        [handleRemoveCoupon]
    );
    if (loading) {
        return null;
    }
    return (
        <Box px={2} pb={1} pt={1}>
            <Typography className={classes.title}>{t('CHECKOUT_COUPON_TITLE')}</Typography>
            <Box>{coupons?.map(renderCoupon)}</Box>
            <Box mt={2}>
                <CouponInput onAdd={onAdd} />
            </Box>
            <Box pt={1}>
                <Divider />
            </Box>
        </Box>
    );
};
